import React, { Component } from 'react';
import { debounce } from 'throttle-debounce';
import autobind from 'react-autobind';
import translate from 'app/translations';
import navigate from 'utils/navigate';
import PropTypes from 'prop-types';
import {
  Table, Row, Col, Button, Form, Input, Select,
} from 'antd';
import { FormControl, FormUtils } from 'form-control';
import moment from 'moment-timezone';
import { formPropType } from 'utils/propType';
import ApplicationsDashboardPropType from '../ApplicationsDashboardPropType';

const { Option } = Select;

const APPROVED = 'APPROVED';
const PENDING_REVIEW = 'PENDING_REVIEW';
const INITIAL_STATUS = PENDING_REVIEW;
const PAGE_SIZE = 10;

export class ApplicationListComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;

    this.state = {
      paginationConfig: {
        pageSize: PAGE_SIZE,
        current: 1,
        onChange: this.loadPage,
      },
    };
  }

  componentWillMount() {
    this.loadPage(1, {
      size: PAGE_SIZE,
      status: INITIAL_STATUS,
    });
  }

  getPagination() {
    const { applications } = this.props.dashboard;
    return {
      ...this.state.paginationConfig,
      pageSize: PAGE_SIZE,
      current: applications.page,
      onChange: (page) => {
        const fieldValues = this.props.form.getFieldsValue();
        this.loadPage(page, fieldValues);
      },
      total: applications.totalElements,
    };
  }

  handleSearch() {
    const { form } = this.props;
    form.validateFields((_, values) => {
      this.loadPage(1, values);
    });
  }

  handleRegionSearch(regionName = '') {
    if (regionName.trim().length >= 2) {
      this.props.onFetchRegionsByNameRequest(regionName.trim());
    }
  }

  loadPage(page, filterConfig) {
    this.props.onFetchApplicationListRequest({
      size: PAGE_SIZE,
      page,
      ...filterConfig,
    });
  }

  render() {
    const { form, app } = this.props;

    const {
      applications, isCallInprogress, constants, regionList,
    } = this.props.dashboard;

    const {
      STATUS,
    } = constants;

    const { isAdmin } = app;

    const { records } = applications;

    const timeZone = moment.tz.guess();

    const columns = [
      {
        title: this.t('ApplicationsDashboard.ApplicationList.name'),
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
          <span className="ant-active-blue">
            {record.firstName} {record.lastName}
          </span>
        ),
      },
      {
        title: this.t('ApplicationsDashboard.ApplicationList.email'),
        dataIndex: 'email',
        key: 'email',
        className: 'desktop-only',
        render: data => (
          <span>
            {data}
          </span>
        ),
      },
      {
        title: this.t('ApplicationsDashboard.ApplicationList.regionName'),
        dataIndex: 'regionName',
        key: 'regionName',
        className: 'desktop-only',
        render: data => (
          <span>
            {data}
          </span>
        ),
      },
      {
        title: this.t('ApplicationsDashboard.ApplicationList.completedDate'),
        dataIndex: 'completedDate',
        key: 'completedDate',
        className: 'desktop-only',
        render: data => (
          <span>
            {data ? moment.tz(data, timeZone).format('MMM D, YYYY') : '-'}
          </span>
        ),
      },
      {
        title: this.t('ApplicationsDashboard.ApplicationList.status'),
        dataIndex: 'status',
        key: 'status',
        align: 'right',
        render: data => (
          <span>
            {FormUtils.getSelectDisplayText(STATUS, 'name', 'value', data)}
          </span>
        ),
      },
    ];

    return (
      <div>
        <h1 className="margin-zero">{this.t('ApplicationsDashboard.ApplicationList.heading')}</h1>
        <div
          className="card-container responsive-border"
          style={{
            paddingBottom: 0,
          }}
        >
          <h2 className="orange-text">{this.t('Generic.search')}</h2>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col md={24} lg={6}>
                <FormControl
                  form={form}
                  fieldName="lastName"
                  displayName={this.t('ApplicationsDashboard.ApplicationList.lastName')}
                >
                  <Input
                    autoComplete="off"
                    maxLength={100}
                    placeholder={this.t('ApplicationsDashboard.ApplicationList.lastName')}
                  />
                </FormControl>
              </Col>
              <Col md={24} lg={6}>
                <FormControl
                  form={form}
                  fieldName="status"
                  displayName={this.t('ApplicationsDashboard.ApplicationList.status')}
                  initialValue={STATUS && STATUS.length ? INITIAL_STATUS : undefined}
                >
                  <Select
                    showSearch
                    autoComplete="off"
                    placeholder={this.t('ApplicationsDashboard.ApplicationList.status')}
                    filterOption={(userInput, option) => FormUtils.filterOptions(userInput, option)}
                  >
                    {
                      STATUS
                        .filter(s => isAdmin || s.value !== APPROVED)
                        .map(kv => (<Option value={kv.value} key={kv.value}>{kv.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
              <Col md={24} lg={6}>
                <FormControl
                  form={form}
                  fieldName="regionId"
                  initialValue={undefined}
                  displayName={this.t('ApplicationsDashboard.ApplicationList.regionName')}
                >
                  <Select
                    showSearch
                    allowClear
                    autoComplete="new-password"
                    filterOption={false}
                    onSearch={debounce(300, this.handleRegionSearch)}
                    placeholder={this.t('ApplicationsDashboard.ApplicationList.regionName')}
                  >
                    {
                      regionList.map(kv => (<Option value={kv.id} key={kv.id}>{kv.name}</Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
              <Col
                md={24}
                lg={6}
                className="align-right"
                style={{ paddingBottom: 24 }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  id="search"
                  className="btn-inline-form"
                  onClick={this.handleSearch}
                  disabled={isCallInprogress}
                >
                  {this.t('Generic.search')}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div>
          <Table
            className="border pointer"
            style={{ borderRadius: 4 }}
            columns={columns}
            dataSource={records}
            rowKey="id"
            pagination={this.getPagination()}
            onRow={record => ({
              onClick: () => { navigate(`/applications/user/${record.id}`); window.scrollTo(0, 0); },
            })}
          />
        </div>
      </div>
    );
  }
}

ApplicationListComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  dashboard: PropTypes.shape(ApplicationsDashboardPropType).isRequired,
  onFetchApplicationListRequest: PropTypes.func.isRequired,
  onFetchRegionsByNameRequest: PropTypes.func.isRequired,
  app: PropTypes.shape({}).isRequired,
};

export default Form.create()(ApplicationListComponent);
